import { useEffect, useState } from "react";
import { Eye, RefreshCw, Inbox } from "lucide-react";

const device = (ua) => {
  if (/iPhone|Android.*Mobile/i.test(ua)) return "Telefono";
  if (/iPad|Tablet/i.test(ua)) return "Tablet";
  return "Computer";
};

const pageName = (p) => {
  if (p === "/patrizias") return "Presentazione Patrizia's";
  if (p === "/events") return "Presentazione Luxury Events";
  if (p === "/") return "Presentazione white-label";
  return p || "—";
};

export default function Visite() {
  const [rows, setRows] = useState(null);
  const [reqs, setReqs] = useState(null);
  const [error, setError] = useState(false);

  const load = () => {
    setError(false);
    const key = new URLSearchParams(window.location.search).get("k") || sessionStorage.getItem("filata-code") || "";
    const q = `?key=${encodeURIComponent(key)}`;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/access-log${q}`)
      .then((r) => { if (!r.ok) throw new Error("bad status"); return r.json(); })
      .then(setRows)
      .catch(() => { setRows([]); setError(true); });
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/requests${q}`)
      .then((r) => { if (!r.ok) throw new Error("bad status"); return r.json(); })
      .then(setReqs)
      .catch(() => setReqs([]));
  };
  useEffect(load, []);

  return (
    <div className="min-h-screen bg-wine text-bg px-6 md:px-10 py-14" data-testid="visite-page">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-end justify-between gap-4 mb-10">
          <div>
            <p className="font-sans text-[11px] uppercase tracking-[0.3em] text-terracotta mb-3 flex items-center gap-2">
              <Eye className="h-4 w-4" /> Registro riservato
            </p>
            <h1 className="font-serif text-4xl md:text-5xl">Chi ha aperto la presentazione</h1>
          </div>
          <button onClick={load} data-testid="visite-refresh" className="inline-flex items-center gap-2 font-sans text-sm text-bg/70 hover:text-bg transition-colors">
            <RefreshCw className="h-4 w-4" /> Aggiorna
          </button>
        </div>

        {rows === null ? (
          <p className="font-sans text-bg/60">Caricamento…</p>
        ) : error ? (
          <p className="font-sans text-terracotta" data-testid="visite-error">Errore di caricamento — premi "Aggiorna" per riprovare.</p>
        ) : rows.length === 0 ? (
          <p className="font-sans text-bg/60" data-testid="visite-empty">Nessuna apertura registrata finora.</p>
        ) : (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8" data-testid="visite-counts">
              {Object.entries(rows.reduce((a, r) => ({ ...a, [r.name]: (a[r.name] || 0) + 1 }), {})).map(([name, n]) => (
                <div key={name} className="border border-bg/15 rounded-sm px-5 py-4">
                  <p className="font-serif text-4xl text-terracotta leading-none">{n}</p>
                  <p className="font-sans text-xs uppercase tracking-[0.2em] text-bg/60 mt-2">
                    {n === 1 ? "apertura" : "aperture"} · {name}
                  </p>
                </div>
              ))}
              <div className="border border-bg/15 rounded-sm px-5 py-4 bg-bg/5">
                <p className="font-serif text-4xl text-bg leading-none">{rows.length}</p>
                <p className="font-sans text-xs uppercase tracking-[0.2em] text-bg/60 mt-2">totale</p>
              </div>
            </div>
            <div className="border border-bg/15 rounded-sm overflow-hidden" data-testid="visite-table">
            {rows.map((r) => (
              <div key={r.id} className="flex flex-wrap items-baseline gap-x-6 gap-y-1 px-5 py-4 border-b border-bg/10 last:border-0">
                <span className="font-serif text-2xl text-terracotta w-28">{r.name}</span>
                <span className="font-sans text-sm text-bg/80">
                  {new Date(r.created_at).toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short" })}
                </span>
                <span className="font-sans text-sm text-bg/60">{pageName(r.path)}</span>
                <span className="font-sans text-xs text-bg/40 ml-auto">{device(r.user_agent)}</span>
              </div>
            ))}
            </div>
          </>
        )}
        <div className="mt-16" data-testid="richieste-section">
          <p className="font-sans text-[11px] uppercase tracking-[0.3em] text-terracotta mb-3 flex items-center gap-2">
            <Inbox className="h-4 w-4" /> Richieste dal form
          </p>
          <h2 className="font-serif text-3xl md:text-4xl mb-8">Richieste di presentazione</h2>
          {reqs === null ? (
            <p className="font-sans text-bg/60">Caricamento…</p>
          ) : reqs.length === 0 ? (
            <p className="font-sans text-bg/60" data-testid="richieste-empty">Nessuna richiesta ricevuta finora.</p>
          ) : (
            <div className="space-y-4" data-testid="richieste-list">
              {reqs.map((q) => (
                <div key={q.id} className="border border-bg/15 rounded-sm px-5 py-5">
                  <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                    <span className="font-serif text-2xl text-terracotta">{q.name}</span>
                    {q.role && <span className="font-sans text-sm text-bg/70">{q.role}</span>}
                    <span className="font-sans text-xs text-bg/40 ml-auto">
                      {new Date(q.created_at).toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short" })}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-x-6 gap-y-1 mt-3 font-sans text-sm text-bg/80">
                    <span>{q.email}</span>
                    {q.phone && <span>{q.phone}</span>}
                  </div>
                  <div className="flex flex-wrap gap-x-6 gap-y-1 mt-2 font-sans text-sm text-bg/60">
                    <span className="text-bg/80">{q.experience || q.type}</span>
                    {q.guests && <span>Ospiti: {q.guests}</span>}
                    {q.location && <span>{q.location}</span>}
                    {q.event_date && <span>{q.event_date}</span>}
                  </div>
                  {q.details && <p className="font-sans text-sm text-bg/50 mt-2 italic">"{q.details}"</p>}
                </div>
              ))}
            </div>
          )}
        </div>

        <p className="font-sans text-xs text-bg/40 mt-8">
          Ogni riga è uno sblocco della presentazione (una per sessione del browser). Pagina riservata, non linkata dal sito.
        </p>
      </div>
    </div>
  );
}
